export default __webpack_public_path__ + "static/iPhoneXFreeMockup2-7e559205400995ce4adf346c4bf237aa.png";